<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-level-track-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>


import VueTypes from "vue-types";

import RLevelTrackTable from "@/modules/redactor/views/level-track/r-level-track-table.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

import { LevelTrack } from "@/modules/redactor/models/level-track/LevelTrack";

export default {
  name: "r-level-track-panel",
  components: {RPanel, RLevelTrackTable},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Level Tracks"),
    items: VueTypes.arrayOf(LevelTrack),
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
